import { Box } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';

import InputComponent from 'UiKit/input';
import SubmitFormButton from 'UiKit/button/submitFormButton';

import usePostForgotPassword from 'Domain/forgot-password/usePostForgotPassword';

import styles from './styles.module.css';
import { useTranslation } from 'react-i18next';

const Form = () => {
  const { register, handleSubmit, formState, watch } = useForm();
  const { mutate: onForgotPassword, isPending } = usePostForgotPassword();
  const { t } = useTranslation('login');

  const onSubmit = (data) => {
    if (isPending) return;

    onForgotPassword(data);
  };

  return (
    <Box className={styles['form__container']} data-testid="forgot-password-form" id="forgot-password-form">
      <form onSubmit={handleSubmit(onSubmit)} data-testid="forgot-password-form-element">
        <InputComponent
          value={watch('email')}
          margin="0 0 24px 0"
          error={formState?.errors?.email}
          label="Email"
          placeholder="hello@paracorpgroup.com"
          register={{
            ...register('email', {
              required: 'Email required!',
              pattern: {
                value: /\S+@\S+\.\S+/,
                message: 'Entered value does not match email format',
              },
            }),
          }}
          data-testid="email-input"
        />

        <SubmitFormButton
          text={t('forgotPasswordPage.buttonSubmit')}
          height="42px"
          width="100%"
          isLoading={isPending}
          isValid={watch('email')}
          data-testid="submit-button"
        />
      </form>
    </Box>
  );
};

export default Form;
